import styled from 'styled-components';

export const AudioContainer = styled.div`
  padding: 6px;
  box-sizing: border-box;
  max-width: 336px;
  width: 250px;
  max-height: 336px;
`;

export const MediaRow = styled.div`
  align-items: center;
  display: flex;
`;

export const AudioControls = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  flex-grow: 1;
`;

export const AudioControlsRow = styled.div`
  align-items: center;
  display: flex;
`;

export const AudioPlay = styled.div`
  flex: none;
  margin-right: 12px;
  margin-top: -1px;
  height: 34px;
  width: 34px;
  position: relative;
  display: block;
`;

export const AudioPlayButton = styled.button<{backgroundColor?: string, textColor?: string}>`
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};
  border: none;
  width: 34px;
  height: 34px;
  position: relative;
  display: block;
  cursor: pointer;
  padding: 0;
  :focus {
    outline: none;
  }
`;

export const AudioProgressContainer = styled.div`
  flex: 1;
`;

export const AudioDuration = styled.div<{textColor?: string}>`
  bottom: 4px;
  color: ${props => props.textColor};
  font-size: 11px;
  line-height: 15px;
  position: absolute;
`;

export const AudioProgress = styled.div`
  position: relative;
  width: 100%;
  top: -1px;
`;

export const AudioProgressSpan = styled.span`
  width: 0;
  position: absolute;
  display: inline;
  left: 0;
  top: 9px;
  height: 3px;
  pointer-events: none;
  z-index: 10;
`;

export const AudioProgressInput = styled.input<{runnableTrackColor?: string, sliderTrackColor?: string}>`
  height: 21px;
  box-sizing: border-box;
  ::-webkit-slider-runnable-track {
    background-color: ${props => props.runnableTrackColor};
    border-top: 1px solid ${props => props.runnableTrackColor} !important;
    border-bottom: 1px solid ${props => props.runnableTrackColor} !important;
  }
  ::-webkit-slider-thumb {
    background-color: ${props => props.sliderTrackColor};
  } 
  background-color: initial !important;
  outline: none !important;
  border: none;
  display: block;
  position: relative;
  width: 100%;
  margin: 0;
  appearance: none;
`;

export const AudioPhotoContainer = styled.div`
  flex: none;
  z-index: 200;
  position: relative;
`;

export const AudioPhoto = styled.div`
  border-radius: 50%;
  background-color: #e6e6e6;
  position: relative;
  overflow: hidden;
  width: 55px;
  height: 55px;
`;

export const AudioPhotoImg = styled.img`
  border-radius: 50%;
  opacity: 1;
  display: block;
  position: relative;
  transition: opacity .15s ease-out;
  width: 100%;
  height: 100%;
  z-index: 100;
  overflow: hidden;
`;

export const AudioPhotoIconContainer = styled.div`
  z-index: 200;
  position: absolute;
  bottom: -2px;
`;

export const AudioPhotoIcon = styled.div`
  width: 19px;
  height: 26px;
  z-index: 100;
`;